import { render, staticRenderFns } from "./BoardCardView.vue?vue&type=template&id=5bc8f972&scoped=true&"
import script from "./BoardCardView.vue?vue&type=script&lang=js&"
export * from "./BoardCardView.vue?vue&type=script&lang=js&"
import style0 from "./BoardCardView.vue?vue&type=style&index=0&id=5bc8f972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc8f972",
  null
  
)

export default component.exports